import React from 'react';
import { Skeleton, Alert, Empty } from 'antd';
import PipelineStageBarChart from './PipelineStageBarChart';
import type { BusinessOverviewFunnelStage } from '../api/businessOverview';
import type { PipelineStageActivityItem } from './PipelineStageBarChart';

interface Props {
  stages: BusinessOverviewFunnelStage[] | undefined;
  isLoading: boolean;
  isError: boolean;
}

const BusinessOverviewFunnelChart: React.FC<Props> = ({ stages, isLoading, isError }) => {
  if (isLoading && stages === undefined) {
    return <Skeleton active paragraph={{ rows: 4 }} />;
  }

  if (isError) {
    return <Alert message="Failed to load pipeline funnel" type="error" showIcon />;
  }

  if (!stages || stages.length === 0) {
    return <Empty description="No pipeline data found." />;
  }

  const stageColors = ['#5DCAA5', '#EF9F27', '#7F77DD', '#D85A30', '#378ADD', '#1D9E75'];

  const chartItems: PipelineStageActivityItem[] = stages.map((stage, index) => ({
    stageId: stage.stageId,
    stageLabel: stage.stageLabel,
    dotColor: stageColors[index % stageColors.length],
    actionCount: stage.dealCount,
    activeRepCount: 0,
    description: `${stage.dealCount} deals · ${stage.totalAmount.toLocaleString(undefined, { maximumFractionDigits: 0 })}`,
  }));

  return <PipelineStageBarChart stages={chartItems} height={280} />;
};

export default BusinessOverviewFunnelChart;
